<emm-management-layout>
  <emm-progress-bar [isLoading$]="centerLoading$"></emm-progress-bar>
  <emm-search-filter
    [addDialog]="true"
    [attr.data-testid]="'operator_locks_search_bar'"
    [displaySearchWithOptions]="false"
    [fields]="fields"
    [isAdminOrAuthor]="(this.isAdmin || this.isAuthor) && !isMMSAuthor"
    [isSuperAdmin]="this.isSuperAdmin"
    layout-center-header
    (add)="openCreateEmergencyItemDialog()"
    (filter)="onFilter($event)"
  ></emm-search-filter>
  @if ((nodes$ | async)?.length > 0) {
    <emm-generic-items-tree
      [contextMenuActions]="emergencyItemsContextMenuActions"
      [disableContextActions]="centerLoading$ | async"
      [items]="nodes$ | async"
      layout-center-content
      [options]="options"
      [readonly]="isReadOnly$ | async"
      [nodesToExpand]="nodesToExpand"
    ></emm-generic-items-tree>
  }
  @if (emergencyItemDetail$ | async; as emergency) {
    <emm-management-attributes-header
      layout-right-header
      [name]="emergency['name']"
      [tag]="emergency.tag"
    ></emm-management-attributes-header>
  }
  <emm-operator-locks-form
    #form
    layout-right-content
    [isSuperAdmin]="isSuperAdmin"
    [isAdmin]="isAdmin"
    [isAuthor]="isAuthor"
  ></emm-operator-locks-form>
  @if ((emergencyItemDetail$ | async) && !isMMSAuthor) {
    <emm-management-attributes-footer
      [disableCancel]="!emergencyItemsForm || !emergencyItemsForm.isFormReady()"
      [disableUpdate]="!emergencyItemsForm || !emergencyItemsForm.hasChanges()"
      layout-right-footer
      (cancel)="emergencyItemsForm.cancel()"
      (submit)="submitForm()"
      class="emergency-items-footer"
    ></emm-management-attributes-footer>
  }
</emm-management-layout>
